let globalState = {
  isDarkMode: false,
  themePalets: null,
  user: null,
  initialLoader: false,
  decodeFn: null,
  encodeFn: null
};

let listeners = [];

export const setGlobalState = (key, val) => {
  if (key) {
    globalState[key] = val;
    listeners.forEach(l => l(globalState));
  }
};

export const getGlobalState = (key) => globalState[key] || null;

export const subscribeGlobalState = (listener) => {
  listeners.push(listener);
  return () => {
    listeners = listeners.filter(l => l !== listener);
  };
};